import { j as t } from "./atoms-v218.js";
import { InputContainer as e } from "./atoms-v2114.js";
import { SkeletonRow as p } from "./atoms-v2778.js";
import "./atoms-v2867.js";
import { SkeletonInput as n } from "./atoms-v2747.js";
const f = ({
  className: r,
  helperText: i,
  variant: o = "productive"
}) => /* @__PURE__ */ t.jsxs(e, { className: r, variant: o, children: [
  /* @__PURE__ */ t.jsx(n, { $variant: o }),
  i && /* @__PURE__ */ t.jsx(p, { height: "8px", width: "50%" })
] });
export {
  f as DigitInputSkeleton
};
